import { FieldTypes, ActionConfigs, Sizes, Types, Align, Backdrop, ModalDefaults, TextAreaLabelPlacements } from '../Constants';

export class GenericActionBuilder {
    constructor(key) {
        const base = ActionConfigs[key.toLowerCase()] || {};
        this.cfg = {
            icon: base.icon || 'bi-circle',
            color: base.color || '#64748b',
            title: base.title || key,
            btnClass: base.btnClass || `gm-btn-${key.toLowerCase()}`
        };
    }

    withIcon(icon) {
        this.cfg.icon = icon;
        return this;
    }

    withColor(color) {
        this.cfg.color = color;
        return this;
    }

    withTitle(title) {
        this.cfg.title = title;
        return this;
    }

    withClass(btnClass) {
        this.cfg.btnClass = btnClass;
        return this;
    }

    build() {
        return this.cfg;
    }
}
